/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ city: NonNullable<unknown> }} Directory_Title_Everyone_CityInputs */

const en_directory_title_everyone_city = /** @type {(inputs: Directory_Title_Everyone_CityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Specialists · ${i?.city}`)
};

const pl_directory_title_everyone_city = /** @type {(inputs: Directory_Title_Everyone_CityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Specjaliści · ${i?.city}`)
};

/**
* | output |
* | --- |
* | "Specialists · {city}" |
*
* @param {Directory_Title_Everyone_CityInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_title_everyone_city = /** @type {((inputs: Directory_Title_Everyone_CityInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Title_Everyone_CityInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_title_everyone_city(inputs)
	return en_directory_title_everyone_city(inputs)
});